import { theme, Avatar, AvatarSize, IconDictionary, Tab, TabGroup } from '@ketch-com/deck'
import { useState } from 'react'
import { Box, Typography } from '@mui/material'
import { ClassificationType } from '@ketch-com/windlass/dist/dataSentry/v1/events/events'
import { Drawer } from 'components/ui-kit/drawer/Drawer'
import { useDataSentryContext } from 'pages/dataSentry/context/DataSentryContext'
import { CollectionDetails } from 'pages/dataSentry/data/dataClassificationDetails/CollectionDetails'
import { Overview } from 'pages/dataSentry/data/dataClassificationDetails/Overview'
import { AssetsTabTableLabelChip } from 'pages/dataSystems/DataSystem/assetsTab/components/AssetsTabTableLabelChip'
import { classificationTypeTitles, enumToLabelChipVariantMap } from 'pages/dataSentry/constants'

export const DataClassificationDetails: React.FC = () => {
  const [tab, setTab] = useState(0)
  const { dataClassificationDetails, setDataClassificationDetails, selectedProperty } = useDataSentryContext()

  let classificationType = classificationTypeTitles[ClassificationType.UNSPECIFIED]
  if (dataClassificationDetails?.type === ClassificationType.DATA_CATEGORY) {
    classificationType = classificationTypeTitles[ClassificationType.DATA_CATEGORY]
  } else if (dataClassificationDetails?.type === ClassificationType.DATA_SENSITIVITY) {
    classificationType = classificationTypeTitles[ClassificationType.DATA_SENSITIVITY]
  } else if (dataClassificationDetails?.type === ClassificationType.DATA_TYPE) {
    classificationType = classificationTypeTitles[ClassificationType.DATA_TYPE]
  }
  return (
    <Drawer
      open={Boolean(dataClassificationDetails)}
      onClose={() => setDataClassificationDetails(null)}
      PaperProps={{
        sx: {
          height: '90%',
          width: '100%',
          maxWidth: '1300px',
          margin: 'auto',
          padding: '32px',
          borderRadius: '37px 37px 0px 0px',
          overflow: 'hidden',
        },
      }}
    >
      <Box display="flex" flexDirection="column" gap={3}>
        <Box display="flex" alignItems="center" gap={1}>
          <Typography variant="h3" color={theme.palette.Text.Secondary}>
            {classificationType}
          </Typography>
          <Box mt={0.5}>
            <AssetsTabTableLabelChip
              title={dataClassificationDetails?.name || dataClassificationDetails?.code}
              variant={enumToLabelChipVariantMap[dataClassificationDetails?.type || ClassificationType.UNSPECIFIED]}
              hideConfidence
              hideIcon
              isViewOnly
              supportMultiLineTitle
            />
          </Box>
          <Typography variant="h3" color={theme.palette.Text.Secondary}>
            on
          </Typography>
          <Avatar
            borderColor={theme.palette.Black.o8}
            icon={IconDictionary.OGlobe}
            textColor={theme.palette.Black.o48}
            size={AvatarSize['medium']}
            variant="square"
            sx={{ borderRadius: 1.5 }}
          />
          <Typography variant="h3">{selectedProperty?.name || selectedProperty?.code}</Typography>
        </Box>
        <TabGroup value={tab} onChange={(event: React.SyntheticEvent, newValue: number) => setTab(newValue)}>
          <Tab size={'medium'} label="Overview" />
          <Tab size={'medium'} label="Collection Details" />
        </TabGroup>

        {tab === 0 ? <Overview /> : null}
        {tab === 1 ? <CollectionDetails /> : null}
      </Box>
    </Drawer>
  )
}
